import React, { useEffect, useState } from "react";
import {
  AddCommentAvatar,
  AddCommentContainter,
  CommentField,
  CommentListContainer,
} from "./comments-view.styles";
import { SpinnerLoader } from "../../../../components/loaders";
import { CommentsList } from "../comments-list/comments-list.component";
import Avatar from "@material-ui/core/Avatar";
import { CommentButton } from "../../../../components/form-controls/button/comment-button/comment-button.component";
import { CommentsViewProps } from "./comments-view.props";
import { FormLabel } from "@material-ui/core";

export const CommentsView = (props: CommentsViewProps) => {
  const [disabledSubmit, setDisabledSubmit] = useState(true);
  const [commentText, setCommentText] = useState("");

  useEffect(() => {
    if (!props.isLoading) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [props.isLoading]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setDisabledSubmit(false);
    } else {
      setDisabledSubmit(true);
    }
    setCommentText(e.target.value);
  };

  const handleAddComment = () => {
    setCommentText("");
    props.onPostComment(commentText);
  };

  return (
    <CommentListContainer>
      <SpinnerLoader showIf={props.isLoading} size={40} />
      <CommentsList showIf={!props.isLoading} comments={props.comments} user={props.user} />
      <AddCommentContainter>
        <AddCommentAvatar>
          <Avatar
            title={`${props.user.firstName} ${props.user.lastName}`}
            alt={`${props.user.firstName} ${props.user.lastName}`}
            src={(props.user.profileImageUrl) ? props.user.profileImageUrl : "/profile.png" }
          />
        </AddCommentAvatar>
        <FormLabel htmlFor="newComment">Comment</FormLabel>
        <CommentField
          id="newComment"
          type="text"
          value={commentText}
          multiline={true}
          onChange={handleChange}
        />
        <CommentButton onClick={handleAddComment} disabled={disabledSubmit}>
          Add Comment
        </CommentButton>
      </AddCommentContainter>
    </CommentListContainer>
  );
};
